import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { ENABLED_FEATURES } from "@/util";
import {
  artifactGenerationApiStore,
  artifactSaveStore,
  artifactApiStore,
} from "@/hooks";
import {
  ArtifactInput,
  ArtifactTypeInput,
  AttributeListInput,
  TextInput,
  IconButton,
} from "@/components/common";

/**
 * Generates the name of the artifact based on the body.
 */

/**
 * Inputs for artifact creation and editing.
 */
const __default__ = {
  name: "SaveArtifactInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleGenerateName() {
  artifactGenerationApiStore.handleGenerateName();
}

/**
 * Generates the body of the artifact based on a prompt.
 */
function handleGenerateBody() {
  artifactGenerationApiStore.handleGenerateBody();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TextInput), {
      modelValue: _unref(artifactSaveStore).editedArtifact.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(artifactSaveStore).editedArtifact.name) = $event)),
      label: "Artifact Name",
      hint: "Enter a unique name for the artifact",
      "error-message": _unref(artifactApiStore).nameError,
      loading: _unref(artifactApiStore).nameLoading,
      class: "q-mb-md",
      "data-cy": "input-artifact-name"
    }, {
      append: _withCtx(() => [
        (_unref(ENABLED_FEATURES).ARTIFACT_PROMPTS)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 0,
              loading: _unref(artifactGenerationApiStore).nameGenLoading,
              tooltip: "Generate the name based on the body",
              icon: "generate",
              onClick: handleGenerateName
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "error-message", "loading"]),
    _createVNode(_unref(ArtifactTypeInput), {
      modelValue: _unref(artifactSaveStore).editedArtifact.type,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(artifactSaveStore).editedArtifact.type) = $event)),
      label: "Artifact Type",
      hint: "Press enter to save a new artifact type",
      class: "q-mb-md",
      "data-cy": "input-artifact-type"
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(TextInput), {
      modelValue: _unref(artifactSaveStore).editedArtifact.body,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(artifactSaveStore).editedArtifact.body) = $event)),
      label: "Artifact Body",
      type: "textarea",
      hint: "Required",
      class: "q-mb-md",
      "data-cy": "input-artifact-body"
    }, {
      append: _withCtx(() => [
        (_unref(ENABLED_FEATURES).ARTIFACT_PROMPTS)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 0,
              loading: _unref(artifactGenerationApiStore).bodyGenLoading,
              tooltip: "Generate the body based on a prompt",
              icon: "generate",
              onClick: handleGenerateBody
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(artifactSaveStore).hasSummary)
      ? (_openBlock(), _createBlock(_unref(TextInput), {
          key: 0,
          modelValue: _unref(artifactSaveStore).editedArtifact.summary,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(artifactSaveStore).editedArtifact.summary) = $event)),
          label: "Artifact Summary",
          type: "textarea",
          class: "q-mb-md",
          "data-cy": "input-artifact-summary"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (!_unref(artifactSaveStore).isUpdate)
      ? (_openBlock(), _createBlock(_unref(ArtifactInput), {
          key: 1,
          modelValue: _unref(artifactSaveStore).parentIds,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(artifactSaveStore).parentIds) = $event)),
          multiple: "",
          "only-document-artifacts": "",
          label: "Parent Artifacts",
          "data-cy": "input-artifact-parent",
          class: "q-mb-md"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (!_unref(artifactSaveStore).isUpdate)
      ? (_openBlock(), _createBlock(_unref(ArtifactInput), {
          key: 2,
          modelValue: _unref(artifactSaveStore).childIds,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(artifactSaveStore).childIds) = $event)),
          multiple: "",
          "only-document-artifacts": "",
          label: "Child Artifacts",
          "data-cy": "input-artifact-child",
          class: "q-mb-md"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(AttributeListInput), {
      artifact: _unref(artifactSaveStore).editedArtifact
    }, null, 8, ["artifact"])
  ]))
}
}

})